import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid } from "@mui/material";
import { api, Credential, CredentialType, IListCustomerItem, IListCustomers, RequestStatus } from "../../../logic/api";
import propTypes from "prop-types";
import { formatCamel } from "../../../utility/utils";
import NotchedCard from "../../../components/cards/NotchedCard/NotchedCard";
import EditableField, { EditableFieldTypes } from "../../../components/editable/EditableField/EditableField";
import { IDropDownListItem } from "../../../components/editable/EditableField/fields/DropDownField";
import EditableGroup, { EditableGroupType } from "../../../components/editable/EditableGroup/EditableGroup";
import { SessionContext } from "../../../utility/useSession";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { ProgressView } from "../../../components/notifications/progress/ProgressView";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import flex from "../../../styles/flex";
import { useTranslation } from "react-i18next";
const CredentialEditorDialog: React.FunctionComponent<{
  credential: Credential;
  show: boolean;
  onClose: (didSave: boolean, credential: Credential | null) => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const [credential, setCredential] = useState(props.credential);

  const [databaseIds, setDatabaseIds] = useState<number[]>([]);

  const saveCredential = api.hooks.admin.saveCredential();
  const [listCustomerParams] = useState<IListCustomers>(
    {}
  );
  useEffect(() => {
    setCredential(props.credential);
    const dbids: number[] = [];
    for (const db of props.credential.databases) {
      dbids.push(db.database.id);
    }
    setDatabaseIds(dbids);
    console.log(dbids);
  }, [props.credential]);

  const isCurrentUser = session.current.site == null ? false : credential.id == session.current.site.user.id;

  const isLoading =
    saveCredential.status == RequestStatus.loading;

  return <Dialog
    maxWidth={isLoading == true ? undefined : "sm"}
    fullWidth={isLoading == true ? false : true}
    open={props.show}
    keepMounted
    onClose={() => props.onClose(false, null)}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    {isLoading == false && (
      <DialogTitle id="alert-dialog-slide-title">
        <div style={{ textAlign: "center" }}>
          {t("admin.credential")}
        </div>
      </DialogTitle>
    )}

    <DialogContent>
      <ErrorDialog err={saveCredential.err}></ErrorDialog>
      <ProgressView
        showError={false}
        noDelay={true}
        status={saveCredential.status}
      >

        <NotchedCard label={t("admin.accessLevel")}>
          <EditableGroup<Credential>
            id="user"
            testId="credential-editor-group"
            editType={EditableGroupType.alwaysEditing}
            data={credential}
            onDataChanged={async (data) => {
              setCredential(data);
              return true;
            }}
          >
            <Grid container>


              <EditableField<Credential, IDropDownListItem>
                inputType={EditableFieldTypes.terminalField}
                label={t("admin.credentialType")}
                readOnly={isCurrentUser == true}
                alwaysVisible={true}
                onProvide={(data) => {
                  return {
                    name: "",
                    value:
                      data.type == null
                        ? CredentialType.user.toString()
                        : data.type.toString(),
                  };
                }}
                onChange={(data, value) => {
                  data.type = parseInt((value.value ?? "").toString());
                }}
                onRequestData={async () => {
                  const items: IDropDownListItem[] = [];

                  const blockedTypes = [
                    CredentialType.service,
                  ];

                  for (const pt in CredentialType) {
                    if (isNaN(parseInt(pt))) {
                      if (blockedTypes.indexOf(parseInt(CredentialType[pt])) == -1) {
                        items.push({
                          name: formatCamel(pt.toString()),
                          value: CredentialType[pt],
                        });
                      }
                    }
                  }
                  return items;
                }}
              />

            </Grid>
          </EditableGroup>
        </NotchedCard>


        <NotchedCard label={t("admin.databaseAccess")}>
          <PagedDataView<IListCustomers, IListCustomerItem>
            apiHook={api.hooks.admin.listCustomers}
            parameters={listCustomerParams}
            renderItem={(item) => {
              return (
                <div style={{ padding: 20 }}>
                  <div style={flex.flexRows}>
                    <div style={flex.flexAuto}>
                      <input style={{ zoom: 1.5 }} type="checkbox" checked={databaseIds.indexOf(item.id) != -1} onChange={() => {
                        const ids = [...databaseIds];
                        const indx = ids.indexOf(item.id);

                        if (indx != -1) {
                          ids.splice(indx, 1);
                        } else {
                          ids.push(item.id);
                        }

                        setDatabaseIds(ids);
                      }} />
                    </div>
                    <div style={flex.flexFill}>
                      <div style={{ marginLeft: 10, marginTop: 2 }}> <b>{item.name}</b></div>
                    </div>
                  </div>
                </div>
              );
            }}
          >
            <div style={{ padding: 20, backgroundColor: "#eee" }}>
              {t("admin.noCustomers")}
            </div>
          </PagedDataView>
        </NotchedCard>

      </ProgressView>
    </DialogContent>
    {isLoading == false && (
      <DialogActions>
        <Button
          onClick={() => {
            props.onClose(false, null);
          }}
          color="primary"
        >
          {t("general.cancel")}
        </Button>
        <Button
          onClick={async () => {
            saveCredential.send(session.current.context, {
              credential,
              databaseIds
            }, (cred) => {
              if (cred == null) {
                return;
              }
              props.onClose(true, cred);
            });
          }}
          color="primary"
        >
          {t("general.save")}
        </Button>
      </DialogActions>
    )}

  </Dialog>;
}

CredentialEditorDialog.propTypes = {
  credential: propTypes.any,
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
};

export default CredentialEditorDialog;
